import React from 'react';
import Wishlist from 'src/components/Wishlist';
import CloseIcon from './components/CloseIcon';
import HotelCardStars from '../HotelCardStars';
import HotelCardLocation from '../HotelCardLocation';
import HotelCardTitle from '../HotelCardTitle';

import styles from './hotelCardMapTitleBlock.module.css';

type HotelCardMapTitleBlockProps = {
  id: number;
  price: number;
  stars: number;
  hotelName: string;
  hotelLocation: string;
  hotelPageHref: string;
  openInCurrentTab: boolean;
  onCloseIconClick: () => void;
};

const HotelCardMapTitleBlock: React.FC<HotelCardMapTitleBlockProps> = ({
  id,
  price,
  stars,
  hotelLocation,
  hotelName,
  hotelPageHref,
  openInCurrentTab,
  onCloseIconClick,
}) => (
  <div className={styles.container}>
    <div>
      <HotelCardStars value={stars} />
      <HotelCardTitle
        hotelPageHref={hotelPageHref}
        isMobile={false}
        isMapCard
        openInCurrentTab={openInCurrentTab}
      >
        {hotelName}
      </HotelCardTitle>
      <HotelCardLocation isMobile={false}>{hotelLocation}</HotelCardLocation>
    </div>
    <div className={styles.buttonsBlock}>
      <Wishlist
        price={price}
        type="hotel"
        wishlistIdentifier={id}
        isWhiteHeart={false}
        isHotelCardFromMap
      />
      <CloseIcon onClick={onCloseIconClick} />
    </div>
  </div>
);

export default HotelCardMapTitleBlock;
